import { render, staticRenderFns } from "./GlobalUpload.vue?vue&type=template&id=02197994&scoped=true"
import script from "./GlobalUpload.vue?vue&type=script&lang=js"
export * from "./GlobalUpload.vue?vue&type=script&lang=js"
import style0 from "./GlobalUpload.vue?vue&type=style&index=0&id=02197994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02197994",
  null
  
)

export default component.exports